// --- START OF FILE App.js ---

import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AuthView } from './components/views/AuthView';
import { GameContainer } from './components/GameContainer';
import { PasscodeView } from './components/views/PasscodeView';
import { Toaster } from 'react-hot-toast'; // Import Toaster

const AppContent = () => {
  const { currentUser, logout } = useAuth();
  
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const sessionVerified = sessionStorage.getItem('isVerified');
    if (sessionVerified === 'true') {
      setIsVerified(true);
    }
  }, [currentUser]);

  const handleVerifyPasscode = (enteredPasscode) => {
    if (enteredPasscode === process.env.REACT_APP_ACCESS_PASSCODE) {
      sessionStorage.setItem('isVerified', 'true');
      setIsVerified(true);
      return true;
    }
    return false;
  };
  
  const handleLogoutAndClearSession = () => {
    sessionStorage.removeItem('isVerified');
    logout();
  }

  if (!currentUser) {
    return <AuthView />;
  }
  
  if (!isVerified) {
    return <PasscodeView onVerify={handleVerifyPasscode} onLogout={handleLogoutAndClearSession} />;
  }
  
  return <GameContainer />;
};

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-slate-900 text-white font-sans">
        {/* Add the Toaster component here */}
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: '#334155', // slate-700
              color: '#fff',
            },
          }}
        />
        <AppContent />
      </div>
    </AuthProvider>
  );
}

export default App;